export default "__VITE_ASSET__9ece06f1__"